function showProject(projectImageUrl,projectId) {

	// Hide the image with the circle background and wait until that
		// animation is completed before we add the new image and then
		// remove the foreground.
		if($('#circle').hasClass('hide')) {
			$('#circle').removeClass('hide');
			$('.caseInfo').fadeOut(1000);
		}

		setTimeout(function() {

			// Load image to an image element, and once we know it's done, add it to
			// our background.
			// $('<img/>').attr('src', 'http://picture.de/image.png').on('load', function() {
			// 	$(this).remove();
			// 	$('body').css('background-image', 'url(http://picture.de/image.png)');
			// });
			// 
			//$('#circle').addClass('hide');
			$('#casesBackground')
			.css('background-image','url("'+projectImageUrl+'")')
			.waitForImages(function() {
				$('#circle').addClass('hide');
				$('#case-'+projectId).fadeIn(1000);
				setTimeout(function() {
					$('html').removeClass('project-loading');
				}, 1000);

			}, $.noop, true);



			//console.log(projectImageUrl);
			
			//$('#casesBackground').css('background-image','url("'+projectImageUrl+'")');
		}, 1000);

}
////////////////////////////////////////////////////////////////////////////////
// Background Image Animation
////////////////////////////////////////////////////////////////////////////////
var casesBackground = document.getElementById("casesBackground");
if(casesBackground) {

	var projectLink = $('.project_link');

	projectLink.on('click',function(e){
		e.preventDefault();

		var projectImageUrl = $(this).data('src');
		var projectId = $(this).data('caseid');
		

		// Make sure an image transition is not already in progress.
		if($('html').hasClass('project-loading')) {
		} else 
		{
			$('html').addClass('project-loading');
			showProject(projectImageUrl,projectId);

		}

		

			
		});


	$(window).on("load", function (e) {


	});


} 

